document.addEventListener('DOMContentLoaded', () => {
  // Initially hide the 'after-submit' section
  document.querySelector('.after-submit').style.display = 'none'
  document.querySelector('.feedback-bottom-data').style.display = 'none'

  // Discount code copy functionality
  document.querySelector('.discount-code-copy').addEventListener('click', function () {
    const discountCodeInput = document.querySelector('.discount-code')

    // Select the text inside the input
    discountCodeInput.select()
    discountCodeInput.setSelectionRange(0, 99999) // For mobile compatibility

    // Copy the selected text to the clipboard
    navigator.clipboard
      .writeText(discountCodeInput.value)
      .then(() => {
        // Create a popup notification dynamically
        const popup = document.createElement('div')
        popup.textContent = 'Discount code copied!'
        popup.style.position = 'fixed'
        popup.style.top = '50%'
        popup.style.left = '50%'
        popup.style.transform = 'translate(-50%, -50%)'
        popup.style.backgroundColor = '#8D9AB7'
        popup.style.color = '#dcff9c'
        popup.style.padding = '10px 20px'
        popup.style.borderRadius = '5px'
        popup.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.1)'
        popup.style.zIndex = '1000'
        popup.style.transition = 'opacity 0.3s ease'
        popup.style.opacity = '1'
        popup.style.fontSize = '10px'
        popup.style.textAlign = 'center'

        // Append the popup to the body
        document.body.appendChild(popup)

        // Hide and remove the popup after 3 seconds
        setTimeout(() => {
          popup.style.opacity = '0' // Fade out
          setTimeout(() => {
            popup.remove() // Remove the element from DOM
          }, 300) // Matches the transition duration
        }, 3000)
      })
      .catch((err) => {
        console.error('Failed to copy the discount code: ', err)
      })
  })

  // Check for the 'feedback' query parameter in the URL
  const feedbackExists = new URLSearchParams(window.location.search).has('feedback')

  if (feedbackExists) {
    console.warn('This is True')
    document.querySelector('.before-submit').style.display = 'none'
    document.querySelector('.after-submit').style.display = 'flex'
    document.querySelector('.feedback-bottom-data').style.display = 'none'
  }

  document.querySelector('.feedback-button').addEventListener('click', () => {
    document.querySelector('.before-submit').style.display = 'none'
    document.querySelector('.feedback-bottom-data').style.display = 'block'
    const formRoot = document.querySelector('div[data-forms-id="forms-root-293585"]')
    if (formRoot) {
      formRoot.style.display = 'block'
    }

    // Scroll to the top of the page smoothly
    window.scrollTo({
      top: 0,
      behavior: 'smooth', // Smooth scrolling effect
    })
  })
})
